/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  expense: Yup.array(
    Yup.object().shape({
      expenseCategoryID: Yup.string().required('Please enter the Category '),
      expenseLineItemID: Yup.string().required('Please enter the Expense Item')
    })
  ),
  level1Approver: Yup.string().when(['shortCloseApprovalRequired', 'numberOfLevels'], {
    is: (shortCloseApprovalRequired) => shortCloseApprovalRequired === 'yes',
    then: Yup.string().required('Approver is required'),
    otherwise: Yup.string().notRequired()
  }),
  level2Approver: Yup.string()
    .when(['shortCloseApprovalRequired', 'numberOfLevels'], {
      is: (shortCloseApprovalRequired, numberOfLevels) => shortCloseApprovalRequired === 'yes' && numberOfLevels == 2,
      then: Yup.string().required('Approver is required'),
      otherwise: Yup.string().notRequired()
    })
    .test(
      'is-different-approvers',
      'Level 1 and Level 2 Approvers cannot be the same',
      function validateApprovers(value) {
        const { level1Approver } = this.parent;
        return !value || value !== level1Approver;
      }
    ),
  numberOfLevels: Yup.string().when('shortCloseApprovalRequired', {
    is: 'yes',
    then: Yup.string().required('Number of Levels is required'),
    otherwise: Yup.string().notRequired()
  }),
  level1ApproverEmail: Yup.string().when(['level1Approver', 'shortCloseApprovalRequired', 'numberOfLevels'], {
    is: (level1Approver, shortCloseApprovalRequired, numberOfLevels) => shortCloseApprovalRequired === 'yes'
      && (numberOfLevels == 1 || numberOfLevels == 2)
      && level1Approver === 'vendor',
    then: Yup.string()
      .transform((value) => (value ? value.trim() : value))
      .email('Invalid email address')
      .required('Vendor email is required'),
    otherwise: Yup.string()
      .transform((value) => (value ? value.trim() : value))
      .notRequired()
  }),
  level2ApproverEmail: Yup.string()
    .when(['level2Approver', 'shortCloseApprovalRequired', 'numberOfLevels'], {
      is: (level2Approver, shortCloseApprovalRequired, numberOfLevels) => shortCloseApprovalRequired === 'yes'
        && numberOfLevels == 2
        && level2Approver === 'vendor',
      then: Yup.string()
        .email('Invalid email address')
        .required('Vendor email is required'),
      otherwise: Yup.string().notRequired()
    })
});
export const validateEmailField = (value, level1Approver, level2Approver, shortCloseApprovalRequired, numberOfLevels, fieldType) => {
    const isShortCloseEnabled = shortCloseApprovalRequired === 'yes';
    const trimmedValue = value ? value.trim() : '';
    if (fieldType === 'level1' && isShortCloseEnabled && (numberOfLevels == 1 || numberOfLevels == 2) && level1Approver === 'vendor') {
      if (!trimmedValue || trimmedValue.trim() === '') {
        return 'Vendor email is required';
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedValue)) {
        return 'Invalid email address';
      }
    }

    if (fieldType === 'level2' && isShortCloseEnabled && numberOfLevels == 2 && level2Approver === 'vendor') {
      if (!trimmedValue || trimmedValue.trim() === '') {
        return 'Vendor email is required';
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedValue)) {
        return 'Invalid email address';
      }
    }

    return '';
  };
export const shortCloseApprovalOptions = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
  ];

export const numberOfLevelsOptions = [
    { label: 'Select Level', value: '' },
    { label: '1', value: 1 },
    { label: '2', value: 2 }
  ];
